<template>
  <fieldset :class="`checkmark ${className}`">
    <label
      tabindex="0"
      v-on:keyup.enter="onEnterPress"
      :class="`checkmark__label ${className}`"
    >
      <input
        :class="`checkmark__input ${className}`"
        ref="input"
        type="checkbox"
        :checked="value"
        :disabled="isDisabled"
        @change="change"
      />
      <NettoIcon v-if="value" icon="." />
      <NettoIcon v-else icon="1" />
    </label>
  </fieldset>
</template>

<script>
import NettoIcon from "@/components/NettoIcon";
export default {
  name: "CheckMark",
  components: {
    NettoIcon
  },
  emits: ["input"],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean
    }
  },
  computed: {
    className() {
      const className = this.value ? "on" : "off";
      if (this.isDisabled) {
        return className + ` disabled`;
      }
      return className;
    }
  },
  methods: {
    change() {
      this.$emit("input", this.$refs.input.checked);
    },
    onEnterPress() {
      this.$refs.input.checked = !this.$refs.input.checked;
      this.change();
    }
  }
};
</script>

<style scoped>
.checkmark {
  cursor: pointer;
}
.checkmark__label {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}
.checkmark__input {
  cursor: pointer;
  position: absolute;
  opacity: 0;
  visibility: hidden;
}
i {
  display: block;
  color: #00aeef;
  font-size: 24px;
  line-height: 24px;
}
.disabled {
  cursor: default;
}
</style>
